import React from 'react';
import CatOne from '../../images/catamaran/ODC48-1-1.png';
import CatTwo from '../../images/catamaran/ODC48-5.png';
import ThumbOne from '../../images/catamaran/cat-one.png';
import ThumbTwo from '../../images/catamaran/cat-two.png';

export default class ArticleOne extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <article id={this.props.id} className='content-article article-one flex-group'>
                <section>
                    <section className='intro'>
                        <h2>Welcome</h2>
                        <p>
                            We aim to create the highest quality products with the lowest 
                            possible carbon footprint without compromise. Our catamarans 
                            are stylish, intuitive and liberating and above all provide the 
                            best performance in class. At Odisea Catamarans, we place an 
                            exceptionally high priority on design, comfort and safety.
                        </p>
                    </section>
                    <div className='thumbs'>
                        <img className='thumb-one' src={ThumbOne} alt="" />
                        <img className='thumb-two' src={ThumbTwo} alt="" />
                    </div>
                </section>
                <section>
                    <div className='cat-one'>
                        <img src={CatOne} alt="" />
                    </div>
                </section>
                <section className='flex-group flex-end'>
                    <div className='cat-two'>
                        <img className='margin-bottom-1' src={CatTwo} alt="" />
                        <p>
                            Our vessels are designed to be handled by a couple to make easy 
                            250 mile days in the right conditions with the knowledge that 
                            they can outrun potentially dangerous weather be that in the 
                            tropics, higher latitudes or southern Hemisphere.
                        </p>
                    </div>
                </section>
            </article>
        );
    }
}